/**
 * Formats an amount with its ISO currency code, e.g. "PHP 12,500.00". Every
 * page uses this so one booking shows the same currency everywhere.
 */
export function money(amount, currency = 'USD', { decimals = 2 } = {}) {
  const n = Number(amount);
  if (amount == null || amount === '' || Number.isNaN(n)) return '—';
  const text = n.toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
  return `${currency || 'USD'} ${text}`;
}

export default money;
